/**
 * Helper function to add DARB logo to PDF documents
 */
export const addLogoToPDF = async (doc: any): Promise<boolean> => {
  return new Promise((resolve) => {
    try {
      const logoImg = new Image();
      logoImg.crossOrigin = 'anonymous';
      logoImg.src = '/cropped-pixelcut-export-removebg-2048x691.png';
      
      logoImg.onload = () => {
        try {
          // Add logo at the top left (scaled to fit)
          const logoWidth = 50;
          const logoHeight = (logoImg.height / logoImg.width) * logoWidth;
          doc.addImage(logoImg, 'PNG', 20, 10, logoWidth, logoHeight);
          resolve(true);
        } catch (error) {
          console.error('Error adding logo to PDF:', error);
          resolve(false);
        }
      };
      
      logoImg.onerror = () => {
        console.error('Error loading logo for PDF');
        resolve(false);
      };
      
      // Timeout after 3 seconds
      setTimeout(() => resolve(false), 3000);
    } catch (error) {
      console.error('Error processing logo for PDF:', error);
      resolve(false);
    }
  });
};
















